<template>
  <h1>Muokkaa omia tietoja</h1>
</template>

<script>
export default {};
</script>

<style></style>
